// Cart drawer "Price summary" section (in the scrolling content) and the footer's
// "View price details" link. The drawer is re-rendered from the server after every cart
// change, so the open state is kept on the class and re-applied when the new element connects.
// The section is closed by default; the toggle or the footer link opens it.
if (!customElements.get('cart-price-summary')) {
  customElements.define(
    'cart-price-summary',
    class CartPriceSummary extends HTMLElement {
      static isOpen = false;

      connectedCallback() {
        this.body = this.querySelector('.cart-price-summary__body');
        this.toggle = this.querySelector('[data-price-summary-toggle]');
        this.toggle.addEventListener('click', () => this.setOpen(!CartPriceSummary.isOpen));
        // Restore the state without animation after a cart re-render
        this.classList.add('is-instant');
        this.setOpen(CartPriceSummary.isOpen);
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-instant')));
      }

      // The rows animate open and closed in CSS (.is-open), so the body is made inert
      // instead of hidden while it is closed.
      setOpen(open) {
        CartPriceSummary.isOpen = open;
        this.body.inert = !open;
        this.classList.toggle('is-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
      }

      // Opens the section and scrolls the cart content so the whole section is visible.
      // When it was closed, the scroll waits for the open animation so it uses the full height.
      reveal() {
        const wasOpen = CartPriceSummary.isOpen;
        this.setOpen(true);
        setTimeout(() => this.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), wasOpen ? 0 : 320);
      }
    }
  );
}

// The footer link is outside the summary element, so one delegated listener handles it.
// It survives the drawer re-render because it is bound to the document.
if (!window.cartPriceSummaryLinkBound) {
  window.cartPriceSummaryLinkBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-price-summary-open]');
    if (!link) return;
    const summary = document.getElementById('CartDrawer-PriceSummary');
    if (summary && typeof summary.reveal === 'function') summary.reveal();
  });
}
